import React from "react";

import { QRFRameProps } from "../types";

import { getPreviewFrameFontSize } from "@/utils/qrEditorHelper";

import "../styles.scss";

export const takeawayFrame = (
  props: Omit<QRFRameProps, "frameType">
): React.SVGProps<SVGSVGElement> => {
  const { text, textColor, children, frameColor, frameBackgroundColor, urlQr } = props;

  const fontSize = getPreviewFrameFontSize(text?.length);

  return (
    <svg
      width="96"
      height="128"
      viewBox="0 0 96 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        stroke="#BFBFBF"
      />
      <g opacity="0.951">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.9609 19.5332C10.9609 19.0828 10.9609 18.6325 10.9609 18.1822C11.294 17.5977 11.7999 17.2318 12.4785 17.0844C36.1426 16.9719 59.8068 16.9719 83.4708 17.0844C84.9764 17.4872 85.3979 18.416 84.7356 19.8709C84.5308 20.1325 84.2779 20.3295 83.9767 20.462C59.9754 20.5746 35.974 20.5746 11.9727 20.462C11.5473 20.2324 11.21 19.9228 10.9609 19.5332Z"
          fill={frameColor}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.2063 25.3252C36.0953 25.297 59.9843 25.3252 83.8731 25.4096C85.1169 26.1303 85.3699 27.1154 84.6319 28.365C84.3927 28.5271 84.1397 28.6679 83.8731 28.7872C59.928 28.8998 35.9828 28.8998 12.0377 28.7872C10.9225 28.0837 10.6696 27.1548 11.2788 26.0007C11.5318 25.6682 11.8409 25.443 12.2063 25.3252Z"
          fill={frameColor}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M91.1687 45.9679C91.1687 46.4746 91.1687 46.9812 91.1687 47.4878C90.4054 48.5538 89.4497 48.7509 88.3021 48.0789C86.0817 45.405 83.8616 42.731 81.6413 40.0572C80.471 58.9118 79.3467 77.7699 78.2687 96.6315C78.2486 97.439 78.1363 98.2272 77.9314 98.9958C77.5615 99.4485 77.0838 99.7018 76.4981 99.7557C57.4993 99.8683 38.5007 99.8683 19.5019 99.7557C18.9163 99.7018 18.4386 99.4485 18.0686 98.9958C17.8637 98.2272 17.7513 97.439 17.7313 96.6315C16.6532 77.7699 15.529 58.9118 14.3588 40.0572C12.1385 42.731 9.91824 45.405 7.69797 48.0789C6.55022 48.7509 5.59466 48.5538 4.8313 47.4878C4.8313 46.9812 4.8313 46.4746 4.8313 45.9679C7.91759 42.2847 10.981 38.5694 14.0215 34.8219C14.3933 34.393 14.8149 34.027 15.2862 33.7242C37.0954 33.6116 58.9047 33.6116 80.7138 33.7242C81.1851 34.027 81.6067 34.393 81.9785 34.8219C85.0191 38.5694 88.0825 42.2847 91.1687 45.9679ZM19.6705 37.3551C38.5287 37.1582 57.415 37.13 76.3295 37.2707C74.209 39.9423 72.1291 42.6444 70.0903 45.3768C55.3635 45.4895 40.6365 45.4895 25.9098 45.3768C23.8878 42.6454 21.8081 39.9716 19.6705 37.3551ZM17.9843 41.0704C19.8903 43.4596 21.7733 45.8803 23.6333 48.3322C23.7856 48.535 23.9822 48.6759 24.2235 48.7544C32.1414 48.9498 40.0669 49.0342 48 49.0077C55.9331 49.0342 63.8586 48.9498 71.7765 48.7544C72.0178 48.6759 72.2145 48.535 72.3667 48.3322C74.2216 45.9117 76.0765 43.491 77.9314 41.0704C77.1981 54.3455 76.4111 67.6306 75.5707 80.9258C72.6197 83.4307 69.6687 85.9359 66.7177 88.4408C54.2954 88.5535 41.8733 88.5535 29.451 88.4408C26.4966 85.9041 23.5175 83.399 20.5137 80.9258C19.6177 67.6411 18.7745 54.3561 17.9843 41.0704ZM20.6823 85.8232C22.4575 87.247 24.2001 88.7107 25.9098 90.2141C24.3933 91.5916 22.8475 92.9426 21.2725 94.2672C20.9672 91.4629 20.7705 88.6482 20.6823 85.8232ZM75.1491 85.8232C75.2607 86.1279 75.3169 86.4657 75.3177 86.8365C75.1899 89.3221 74.9933 91.799 74.7275 94.2672C73.1817 92.9443 71.6361 91.6213 70.0903 90.2985C71.8092 88.8294 73.4955 87.3377 75.1491 85.8232ZM29.2823 92.0717C41.761 92.0435 54.2394 92.0717 66.7177 92.1562C68.2915 93.5072 69.8655 94.8582 71.4393 96.2093C55.8131 96.3219 40.187 96.3219 24.5608 96.2093C26.1671 94.8528 27.7411 93.4738 29.2823 92.0717Z"
          fill={frameColor}
        />
      </g>
      <path
        d="M17.6246 39.1174C17.557 37.9687 18.4704 37 19.6211 37H76.3789C77.5296 37 78.443 37.9687 78.3754 39.1174L75.1107 94.6174C75.0486 95.6746 74.1731 96.5 73.1142 96.5H22.8858C21.8269 96.5 20.9514 95.6746 20.8893 94.6174L17.6246 39.1174Z"
        fill={frameBackgroundColor}
      />
      <foreignObject
        width="56%"
        height="54px"
        style={{ borderRadius: "3px" }}
        x="21"
        y="39">
        <div
          id="#qrCode"
          style={{
            border: `1px solid ${frameBackgroundColor || "white"}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            padding: "3px",
            backgroundColor: `${frameBackgroundColor}`,
            paddingTop: "3px",
          }}>
          {urlQr ? (
            <img
              src={urlQr}
              width="100%"
              height="auto"
            />
          ) : (
            children
          )}
        </div>
      </foreignObject>
      <foreignObject
        width="100%"
        height="18px"
        y="102">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "100%", height: "100%", maxWidth: "100%" }}>
          <text
            x="50%"
            y="11"
            fill={textColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="sans-serif"
            fontWeight="bold"
            style={{ fontSize }}>
            {text}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
